import { Column, Popover, PopoverPlacement, Row, Text } from 'farmhub-ui-core';

import { RootState, useAppSelector } from 'app';
import {
  AppsFilledIcon,
  BeeFilledIcon,
  DashboardFilledIcon,
  QRCodeFilledIcon,
} from 'components/Icon/apps';
import { env } from 'env';
import { theme } from 'styled';
import { isCheckDomain } from 'utils';

import RedirectItem from './RedirectItem';
import { IconWrapper } from './styles';

const Apps = (): JSX.Element => {
  const user = useAppSelector((state: RootState) => state.auth.item);

  const content = (
    <Column styles={{ padding: 6, gap: 18 }} width="260px">
      <Row>
        <Text color="primary" size="xs" weight="bold">
          Điều hướng
        </Text>
      </Row>
      {user?.domain && (
        <>
          <RedirectItem
            color={theme.colors.primary.main}
            description="Sàn thương mại nội bộ"
            hoverBackground={theme.colors.primary.main}
            icon={<BeeFilledIcon />}
            route={user?.domain ?? 'https://stag.hubadmin.asia/'}
            title="HUBBEE"
          />
          <RedirectItem
            color={theme.colors.primary.main}
            description="Quản trị dữ liệu"
            hoverBackground={theme.colors.primary.main}
            icon={<DashboardFilledIcon />}
            route={`${user?.domain ?? 'https://stag.hubadmin.asia/'}/admin`}
            title="HUBADMIN"
          />
        </>
      )}
      <RedirectItem
        color={theme.colors.primary.main}
        description="Truy xuất nguồn gốc"
        hoverBackground={theme.colors.primary.main}
        icon={<QRCodeFilledIcon />}
        route={
          isCheckDomain()
            ? 'https://check.ecomend.ai'
            : env.service.hubcheckWebApp ?? ''
        }
        title="CHECK"
      />
    </Column>
  );

  return (
    <Popover
      containerId="header"
      content={content}
      placement={PopoverPlacement.BottomRight}
      trigger="click"
      width="240px"
    >
      <IconWrapper>
        <AppsFilledIcon />
      </IconWrapper>
    </Popover>
  );
};

export default Apps;
